module.exports = __webpack_public_path__ + "static/img/down-arrow.dca7589f.svg";